import React from "react";
import { CgLogIn } from 'react-icons/cg';



export default function ViewMoreDetailsModal(props) {

  let { AddBalanceModal, handleAppSeetingHideModalAdd, errorsUpdateQuoteAdd, setBalance, addBalanceSubmit, balance, handleResponseDisable } = props;

  return (


    <div className={AddBalanceModal ? "fixed w-full top-0 left-0 h-full inset-0 z-40 overflow-hidden mt-0 flex justify-center items-center overflow-y-auto bg-black/40 md:p-0 p-1" : "hidden"} style={{ marginTop: '0rem', }}  >
      <div className="animate__animated animate__fadeInDown animate__faster bg-[#f8f8fb]  md:w-[32rem] w-full  mx-auto rounded shadow-lg  overflow-y-auto mt-2">
        {/*modal header*/}
        <div className="flex items-center justify-between p-6 py-2 bg-black border-b">
          <p className="text-[16px] font-medium text-white uppercase">Status Of User</p>
          <div className="rounded-full cursor-pointer modal-close ">
            <svg onClick={() => handleAppSeetingHideModalAdd()} className="fill-current text-white/60 hover:text-white/100 " xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18">
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
              </path>
            </svg>
          </div>
        </div>

        <div className="p-4">

          <form autoComplete="off" className="p-4 space-y-4 capitalize border border-gray-300 ">

            {/* <div className="w-full">
              <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Amount :</label>
              <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateQuoteAdd && !errorsUpdateQuoteAdd["balance"] ? "border placeholder-gray-500" : "border border-opacity-100 border-red-500   "}`}
                id="balance" name="balance" placeholder="* Fill your amount"
                type="text" onChange={setBalance}
                value={balance ? balance : ""}
              />
              {errorsUpdateQuoteAdd && errorsUpdateQuoteAdd["balance"] ?
                <div className="text-red-600 text-xs invalid-feedback">
                  {errorsUpdateQuoteAdd["balance"]}
                </div>
                : null}
            </div> */}

            <div className="flex flex-col items-center justify-center  p-10 bg-gray-900">
              {/* Component Start */}
              <form className="w-full max-w-screen-sm space-y-6" action="">
                <div onClick={() => handleResponseDisable({ isDisable: "false" })}>
                  <input
                    className="sr-only peer"
                    type="radio"
                    name="options"
                    id="option_1"
                  />
                  <label
                    className="flex items-center h-14 px-8 bg-gray-700 bg-opacity-50 border border-gray-700 rounded cursor-pointer hover:bg-opacity-60 peer-checked:bg-green-900 peer-checked:border-green-700 ring-opacity-30 ring-green-600 peer-checked:ring-4 group"
                    htmlFor="option_1"
                  >
                    <div className="flex items-center justify-center w-6 h-6 border border-gray-600 rounded-full peer-checked:group:bg-indigo-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className=" w-4 h-4 text-indigo-200 fill-current peer-checked:group:visible"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col ml-6">
                      <span className="text-xl font-medium text-gray-50" >Active</span>

                    </div>
                  </label>
                </div>
                <div onClick={() => handleResponseDisable({ isDisable: "true" })}>
                  <input
                    className="sr-only peer"
                    defaultChecked=""
                    type="radio"
                    name="options"
                    id="option_2"
                  />
                  <label
                    className="flex items-center h-14 px-8 bg-gray-700 bg-opacity-50 border border-gray-700 rounded cursor-pointer hover:bg-opacity-60 peer-checked:bg-red-900 peer-checked:border-red-700 ring-opacity-30 ring-red-600 peer-checked:ring-4 group"
                    htmlFor="option_2"
                  >
                    <div className="flex items-center justify-center w-6 h-6 border border-gray-600 rounded-full peer-checked:group:bg-indigo-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className=" w-4 h-4 text-indigo-200 fill-current peer-checked:group:visible"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col ml-6">
                      <span className="text-xl font-medium text-gray-50" >Deactive</span>

                    </div>

                  </label>
                </div>


                <button className="flex items-center h-12 px-6 ml-auto bg-indigo-700 rounded text-indigo-50 hover:bg-indigo-600 focus:outline-none focus:ring ring-indigo-500" onClick={addBalanceSubmit}>
                  Submit
                </button>
              </form>
              {/* Component End  */}
            </div>






          </form>

        </div>
        {/*Footer*/}

      </div>
    </div>

  );
}
